import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractValueFormulaToken from "./AbstractValueFormulaToken.js";
import KeyFigureFormulaNode from "../formula/KeyFigureFormulaNode.js";

/**
 * Value token representing a `KeyFigure` within a formula.
 *
 * @param {KeyFigure} spec.keyFigure - KeyFigure represented by the token.
 */
export default class KeyFigureFormulaToken extends AbstractValueFormulaToken {
	constructor({ keyFigure } = {}) {
		super(...arguments);
		this._keyFigure = keyFigure;
	}

	getKeyFigure() {
		return this._keyFigure;
	}

	setKeyFigure(keyFigure) {
		this._keyFigure = keyFigure;
	}

	getKeyFigureName() {
		return this._keyFigure.getName();
	}

	accept(visitor) {
		return visitor.visitKeyFigureFormulaToken(this);
	}

	_asBaseFormulaNode() {
		return new KeyFigureFormulaNode({
			keyFigure: this._keyFigure,
			visible: true,
		});
	}

	static getLabel() {
		return _("Key figure");
	}

	static getType() {
		return "keyfigure";
	}

	static newDefault({ keyFigures }) {
		return new this({
			keyFigure: keyFigures.find((kpi) => kpi.getId() === "NetSales"),
		});
	}
}
